<template>
    <div class="company-general">
        <v-row class="mx-0">
            <v-col cols="12" class="col-sm-6 px-0">
                <v-row class="mx-0">
                    <v-col cols="12" class="text-center">
                        <v-img :src="logo"  class="company-image my-3" max-height="280" contain/>
                    </v-col>
                    <v-col cols="12" class="col-sm-6 d-flex align-center">
                        <v-file-input
                                color="teal"
                                :rules="rules"
                                v-model="imageFile"
                                accept="image/png, image/jpeg, image/bmp"
                                placeholder="Выберите файл (jpg, jpeg, png)"
                                prepend-icon="mdi-camera"
                                label="Выберите файл (jpg, jpeg, png)"
                        ></v-file-input>
                    </v-col>
                    <v-col cols="12" class="col-sm-6 d-flex align-center justify-center">
                        <v-btn
                                icon
                                color="teal"
                                class="text-capitalize mr-2"
                                @click="uploadImage"
                                :disabled="!imageFile"
                        >
                            <v-icon large>check</v-icon>
                        </v-btn>
                        <v-btn
                                v-if="logo"
                                icon
                                class="text-capitalize"
                                @click="showDeleteImageSnack"
                        >
                            <v-icon large>close</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
            <v-col cols="12" class="col-sm-6 px-0">
                <v-col cols="12">
                    <v-text-field v-model="company.address" label="Адрес (основной)" color="teal" @change="companyChange"/>
                </v-col>
                <v-col cols="12">
                    <v-text-field v-model="company.email" label="Email (основной)" color="teal" @change="companyChange"/>
                </v-col>
                <v-col cols="12">
                    <v-text-field v-model="company.phone" label="Номер телефона (основной)" color="teal" @change="companyChange"/>
                </v-col>
                <v-col cols="12">
                    <v-text-field v-model="company.siteLink" label="Сайт" color="teal" @change="companyChange"/>
                </v-col>
            </v-col>
        </v-row>
        <v-row v-if="company.langs && company.langs.length" class="mx-0">
            <v-col cols="12" class="px-0">
                <v-row>
                    <v-col cols="12" class="col-sm-6" v-for="(lang, idx) in company.langs" :key="`name-${idx}`">
                        <v-text-field v-model="company.langs[idx].name" :label="`Название ${lang.languageCode.toUpperCase()}`" color="teal" @change="companyChange"/>
                    </v-col>
                    <v-col cols="12" class="col-sm-6" v-for="(lang, idx) in company.langs" :key="`desc-${idx}`">
                        <ckeditor
                                @change="companyChange"
                                :label="`Описание ${lang.languageCode.toUpperCase()}`"
                                :editor="editor"
                                v-model="company.langs[idx].description"
                                :config="editorConfig"
                                class="border-transparent"
                                :rules="rules.text"
                        ></ckeditor>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-snackbar v-model="snackOpen" :color="snackColor">
            <div v-if="snackText">
                {{ snackText }}
            </div>
            <div v-if="snackDelete" class="d-flex justify-space-between">
                <v-btn text @click="deleteImage">Удалить</v-btn>
                <v-btn text @click="resetSnack">Закрыть</v-btn>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
    import '@ckeditor/ckeditor5-build-classic/build/translations/ru';

    import { CompanyService } from "../../../../services"
    import { MixinAppSnack } from "../../../../mixins"

    export default {
        name: "CompanyGeneral",
        mixins:[MixinAppSnack],
        props:['companyData'],
        data() {
            return {
                editor: ClassicEditor,
                editorConfig: {
                    language: 'ru',
                    label: 'Описание',
                },
                company: {},
                companyImage: null,
                imageFile: null,
                rules: [
                    value => !value || value.size < 2000000 || 'Размер лого должен быть меньше 2 MB',
                ],
            }
        },
        computed: {
            logo() {
                const image = this.company && this.company.image || null;
                return  image ? image.url : '/images/default-user.png';
            },
        },
        methods: {
            companyChange() {
                this.$emit('change', this.company);
            },
            uploadImage(){
                const image = this.imageFile;
                if(!image)
                    return;

                const reader = new FileReader();
                reader.readAsDataURL(image);
                reader.onload = e =>{
                    this.companyImage = e.target.result;
                };

                const formData = new FormData();
                formData.append("image", image);
                formData.append("companyID", this.company.id);

                CompanyService.setAuth(this.$store.getters.token);
                CompanyService.saveImage(formData)
                    .then(res => {
                        if(res.data.error) {
                            return this.imageErrorHandle(res.data.error);
                        }
                        this.company.image = res.data;
                        this.imageFile = null;
                        this.setSnackText('Изменения сохранены');
                        this.setSuccessSnack();
                        this.openSnack();
                        this.companyChange();
                    })
                    .catch(err => {
                        this.imageErrorHandle('Ошибка при сохранении данных');
                        console.log(err);
                    })
            },
            imageErrorHandle(err) {
                this.resetSnack();
                this.setSnackText(err);
                this.setErrorSnack();
                this.openSnack();
            },
            showDeleteImageSnack() {
                this.setSnackText('');
                this.setDeleteSnack();
                this.openSnack();
            },
            deleteImage() {
                CompanyService.setAuth(this.$store.getters.token);
                CompanyService.deleteLogo({ "companyID": this.company.id })
                    .then(res => {
                        if(res.data.error) {
                            return this.imageErrorHandle(res.data.error);
                        }
                        this.company.image = null;
                        this.resetSnack();
                        this.setSnackText('Логотип удален');
                        this.setSuccessSnack();
                        this.openSnack();
                        this.companyChange();
                    })
                    .catch(err => {
                        this.imageErrorHandle('Ошибка при удалении логотипа');
                        console.log(err);
                    });
            }
        },
        created() {
            this.company = Object.create(this.companyData);
        },
        watch: {
            companyData: {
                handler() {
                    this.company = Object.create(this.companyData);
                },
                deep: true
            },
        }
    }
</script>

<style scoped>

</style>